module.exports = require("./pt-TL");